import { getAppServerClient, setAppServerClient } from "@advosys/component-app-server-client-js";
import { mockAppServerClient } from "@advosys/component-app-server-client-js-mock";
import { MobilityMockDataBuilder } from "./mobility-mock-data-builder";
export const mockAppServer = () => {
    const mockData = new MobilityMockDataBuilder().accessToAllModulesV2().allLatestApiCapabilities().matterTypes().matterPenneoFormIsValid().dynamicPreparedInvoicesForApproval().data;
    const myMockedApi = mockAppServerClient(mockData, getAppServerClient());
    setAppServerClient(myMockedApi);
};
